import {TweenMax, TimelineMax, Sine, Power3} from 'gsap';
const Snap = require('snapsvg');
const CustomEase = require('gsap/CustomEase');


const win = window;
const _getSvgToHtmlRatio = require('./svgAnim/getSvgToHtmlRatio');
const __getPointClass = require('./utils/getRiskValueClass');
const __clearPointClass = require('./utils/clearRiskValueClass');
const simpleToCartesian = require('./svgAnim/simpleToCartesian');


const init = function () {
    if (this._initiated) return this;

    this.svg1 = Snap(this.mainVP.querySelector('svg[data-main-svg]'));
    this._el = this.mainVP.querySelector('[data-point-outline]');
    this._parent = this._el.parentNode;
    this.a = this.A0 = Math.PI;
    this.A1 = 0;
    this.A2 = Math.PI;
    this.r = 1;
    this.R = 726 / 2;
    this.cx = 0;
    this.cy = 0;
    this.cmRatio = 1 - 726 / 470;

    this._el.style.opacity = 0;
    this._el.dataset.active = false;
    TweenMax.delayedCall(0.1, _handleResize, [this]);

    _cameraInvalidate(this);
    _invalidate(this);

    this._stage = '';

    this._initiated = true;
    return this;
};

const _cameraInvalidate = d => {
    d._parent.style.transform = `translate(${d.cx * d.cmRatio * d._svgToHtmlRatio}, ${d.cy * d.cmRatio * d._svgToHtmlRatio})`;
}

const _invalidate = d => {
    const p = simpleToCartesian(d.r * d._svgToHtmlRatio, d.a);
    d._el.style.transform = `translate(${p[0]}px, ${p[1]}px)`;
}

const show = function (delay) {
    if (!this._initiated) return this;
    if (this._shown) return this;

    this._shown = true;
    this._handleResize();

    const bounceOut = CustomEase.create('bounceOut', 'M0,0 C0.162,0 0.097,1.083 0.316,1.084 0.47,1.084 0.406,1 1,1');
    const tl = new TimelineMax({
        delay: delay || 0,
        onUpdate: _invalidate,
        onUpdateParams: [this],
        onComplete: () => {
            this._el.dataset.active = true;
        }
    });

    tl.to(this, 2.57, {
        r: this.R,
        ease: bounceOut
    }, 'st');

    tl.to(this, 1.7, {
        a: this.A1,
        ease: Power3.easeOut
    }, 'st+=' + 0.15);

    tl.to(this._el, 0.25, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st+=' + 0.15);

    this._tl = tl;

    _addEventListeners(this, true);
    return this;
};

const hide = function () {
    if (!this._initiated) return this;
    if (!this._shown) return this;

    this._shown = false;
    this._el.dataset.active = false;
    const tl = new TimelineMax({
        onUpdate: _invalidate,
        onUpdateParams: [this]
    });

    tl.to(this, 1, {
        r: this.R,
        ease: Sine.easeIn
    }, 'st');

    tl.to(this, 1, {
        a: this.A2,
        ease: Sine.easeOut
    }, 'st');

    tl.to(this._el, 0.5, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.5);

    this._tl = tl;

    _addEventListeners(this, false);
    return this;
};

const destroy = function () {
    if (!this._initiated) return this;

    _addEventListeners(this, false);

    TweenMax.killDelayedCallsTo(_handleResize);
    if (this._tl) this._tl.kill();
    this.svg1 = null;

    return this;
};


const _setY = function (value) {
    if (this._y === value) return this._y;

    this._y = value;
    this.A1 = -Math.asin(this._y / (this._svgToHtmlRatio * this.R));

    if (!this._initiated || !this._shown) return this._y;

    // animate

    this._el.dataset.active = false;

    const tl = new TimelineMax({
        onUpdate: _invalidate,
        onUpdateParams: [this],
        onComplete: () => {
            this._el.dataset.active = true;
        }
    });
    tl.to(this, 0.7, {
        a: this.A1,
        ease: Sine.easeInOut
    });

    return this._y;
};

const _setValue = function (value) {
    this._value = value;

    __clearPointClass(s => { this._el.classList.remove(s); });
    this._el.classList.add(__getPointClass(this._value));

    return this._value;
};


const _handleResize = d => {
    d._svgToHtmlRatio = _getSvgToHtmlRatio(d.svg1);
    _invalidate(d);
}

const _addEventListeners = (diagram, b) => {
    const d = diagram;

    if (b === false) {
        win.removeEventListener('resize', d._handleResize);
        return;
    }

    win.addEventListener('resize', d._handleResize);
};

module.exports = mainVP => {
    const Diagram = {};
    Diagram.mainVP = mainVP;


    Diagram.init = init.bind(Diagram);
    Diagram.destroy = destroy.bind(Diagram);
    Diagram.show = show.bind(Diagram);
    Diagram.hide = hide.bind(Diagram);
    Diagram.setY = _setY.bind(Diagram);
    Diagram.setValue = _setValue.bind(Diagram);
    Diagram._handleResize = () => { _handleResize(Diagram) };

    return Diagram;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/CentralDiagramOutlinePoint.js